<template>
    <div class="app-view login-wrapper">
        <div class="login-header">
            <a class="login-logo" href="/"><img alt="百度|品牌营销开放平台" src="../common/img/home-logo.svg"></a>
        </div>
        <router-view/>
    </div>
</template>

<script>
export default {
    name: 'App'
};
</script>

<style lang="less">
html,
body {
    margin: 0;
    height: 100%;
    min-width: 1280px;
}
.login-wrapper {
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: hidden;
    min-height: 680px;
    position: absolute;

    .login-header {
        width: 100%;
        height: 50px;
        background: #1e2025;
    }
    .login-logo {
        float: left;
        margin-left: 20px;
        padding-top: 15px;
        box-sizing: border-box;
        img {
            height: 30px;
        }
    }
}
</style>
